import API from "../../../app/api";

export const getCarpetforEverySport = async () => {
  try {
    const res = await API.get("/banners/section/CARPET_FOR_EVERY_SPOT");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Carpet for Every Spot");
    }
    return res.data?.data?.banners || [];
  } catch (error) {
    console.error("getCarpetforEverySpot error:", error);
    return [];
  }
};